export default __webpack_public_path__ + "static/media/1872.f6fbdaa1.png";